import { AgxSpacer } from '@urbanx/agx.ui-components2';
import type { BrandSettings } from '@urbanx/agx.agencies.client';
import * as styles from './DemoBrands.css';

export function DemoBrandPreview({ branding }: { branding: BrandSettings }) {
  return (
    <div
      className={styles.preview}
      data-testid="demo-brand-preview"
      style={{ background: branding.backgroundColor }}
    >
      <div
        className={styles.previewPane}
        style={{
          background: `color-mix(in srgb, ${branding.inboxBackgroundColor} ${branding.inboxBackgroundColorOpacity}%, transparent)`,
        }}
      >
        Inbox text
      </div>
      <div
        className={styles.previewPane}
        style={{
          background: `color-mix(in srgb, ${branding.sidebarBackgroundColor} ${branding.sidebarBackgroundColorOpacity}%, transparent)`,
          color: branding.backgroundTextColor,
        }}
      >
        Sidebar text
      </div>
      <AgxSpacer direction="horizontal" gap="spacing-sm" contentAlignment="center">
        <span
          className={styles.previewPane}
          style={{ background: branding.accentColorOld, color: branding.buttonTextColor }}
        >
          Button
        </span>
        <span className={styles.previewPane} style={{ color: '#FFFFFF' }}>
          Button
        </span>
      </AgxSpacer>
    </div>
  );
}
